import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import GridCheckbox from './GridCheckbox'
import GridCircularProgress from './GridCircularProgress'
import { useGetIscrizioniBySocietaQuery } from '../hooks/api-slice'
import { config } from '../settings/configs'
import { titlesAffiliazione } from '../settings/settings'

const DialogDeleteAffiliazione = ({
  open,
  handleClose,
  triggerFunction,
  affiliazione,
}) => {
  const [deleteAlsoIscrizioni, setDeleteAlsoIscrizioni] = useState()

  const { data: iscrizioni, isFetching } = useGetIscrizioniBySocietaQuery(
    affiliazione?.codiceSocieta,
    { skip: !affiliazione?.codiceSocieta },
  )

  const numeroIscrizioni = iscrizioni?.length

  useEffect(() => {
    setDeleteAlsoIscrizioni()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() =>
        triggerFunction(affiliazione, deleteAlsoIscrizioni)
      }
      title={titlesAffiliazione.titleDelete}
      textUndo='Annulla'
      textConfirm='Ok'
      error
    >
      {!affiliazione ? (
        'Nessuna società selezionata.'
      ) : isFetching ? (
        <GridCircularProgress />
      ) : !config?.features?.iscrizioni ? null : (
        <Grid container spacing={2} sx={{ width: '100%' }}>
          {numeroIscrizioni === 0 ? (
            'Questa società non ha ancora iscritto nessuna squadra.'
          ) : (
            <>
              <Grid size={12}>
                Questa società ha iscritto {numeroIscrizioni}{' '}
                {numeroIscrizioni === 1 ? `squadra` : `squadre`}.
              </Grid>
              <GridCheckbox
                label='Elimina anche le iscrizioni.'
                value={!!deleteAlsoIscrizioni}
                onChange={(_, x) => setDeleteAlsoIscrizioni(x)}
                md={12}
              />
              <Grid size={12}>
                <b>ATTENZIONE</b>: eliminando anche le iscrizioni, verranno
                rimosse anche tutte le relative partite (inclusi spostamenti,
                designazioni e richieste di arbitraggio).
              </Grid>
            </>
          )}
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogDeleteAffiliazione
